import { useState } from "react";
import { liveRooms } from "../../../mocks/chiagua";

const tabs = ["全部直播", "娱乐", "行业", "连麦", "综合", "深夜"];

export default function LiveSection() {
  const [active, setActive] = useState("全部直播");
  const list = active === "全部直播" ? liveRooms : liveRooms.filter((r) => r.category === active);

  return (
    <section id="live" className="bg-background-50 py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4">
          <div>
            <span className="text-primary-600 text-sm font-semibold tracking-widest">LIVE</span>
            <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 mt-2">
              在线围观 · 此刻谁在播
            </h2>
            <p className="text-foreground-600 text-sm md:text-base mt-3">
              挑一间感兴趣的直播间加入现场，弹幕同步吐槽，反转边播边蹲。
            </p>
          </div>
          <div className="inline-flex items-center gap-1 p-1 bg-background-100 rounded-full w-fit">
            {tabs.map((t) => (
              <button
                key={t}
                onClick={() => setActive(t)}
                className={`px-4 py-2 rounded-full text-sm whitespace-nowrap transition-colors cursor-pointer ${
                  active === t
                    ? "bg-primary-500 text-background-50 font-medium"
                    : "text-foreground-600 hover:bg-background-200/60 hover:text-primary-600"
                }`}
              >
                {t}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5 mt-8 md:mt-10">
          {list.map((room) => (
            <article
              key={room.id}
              className="group bg-background-100/60 border border-background-200/70 rounded-2xl overflow-hidden hover:border-primary-300 transition-colors cursor-pointer"
            >
              <div className="relative h-40 md:h-44 overflow-hidden">
                <img
                  src={room.cover}
                  alt={`${room.name}直播间画面`}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-2.5 left-2.5 flex items-center gap-1.5">
                  {room.online ? (
                    <span className="inline-flex items-center gap-1.5 bg-background-950/65 text-background-50 text-xs px-2 py-1 rounded-md whitespace-nowrap">
                      <span className="w-1.5 h-1.5 rounded-full bg-red-500 animate-pulse-dot"></span>
                      直播中
                    </span>
                  ) : (
                    <span className="bg-background-950/65 text-background-200 text-xs px-2 py-1 rounded-md whitespace-nowrap">
                      回放中
                    </span>
                  )}
                  <span className="bg-primary-500 text-background-50 text-xs px-2 py-1 rounded-md whitespace-nowrap">
                    {room.category}
                  </span>
                </div>
                <span className="absolute top-2.5 right-2.5 inline-flex items-center gap-1 text-background-100 text-xs bg-background-950/50 px-2 py-1 rounded-md whitespace-nowrap">
                  <i className="ri-eye-line"></i>
                  {room.viewers}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-foreground-950 font-semibold text-sm md:text-base leading-snug">
                  {room.name}
                </h3>
                <div className="flex items-center justify-between mt-3">
                  <span className="flex items-center gap-1.5 text-foreground-600 text-xs whitespace-nowrap">
                    <i className="ri-user-smile-line text-primary-500 text-sm"></i>
                    {room.host}
                  </span>
                  <a
                    href="#danmaku"
                    className="inline-flex items-center gap-1.5 bg-primary-500 hover:bg-primary-600 text-background-50 text-xs font-medium px-4 py-2 rounded-full whitespace-nowrap transition-colors cursor-pointer"
                  >
                    <i className="ri-vidicon-line"></i>
                    进直播间
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}